import './styles.styl'
import React from 'react'
import { Link } from 'react-router-dom'

export default class UIComponent extends React.Component {
  renderFullMenu () {
    return (
      <div className='menu-inner'>
        <a href='/' className='brand'>iLoyalty</a>

        <ul className='navigation'>
          <li><Link className={this.props.path === '/' ? 'active' : ''} to='/'><i className='fa fa-tachometer' />Dashboard</Link></li>
          <li><Link className={this.props.path === '/customers' ? 'active' : ''} to='/customers'><i className='fa fa-users' />Klanten</Link></li>
          <li><Link className={this.props.path === '/projects' ? 'active' : ''} to='/projects'><i className='fa fa-shopping-cart' />Projecten</Link></li>
          <li><Link className={this.props.path === '/credentials' ? 'active' : ''} to='/credentials'><i className='fa fa-lock' />API credentials</Link></li>
        </ul>
      </div>
    )
  }

  renderCollapsedMenu () {
    return null
  }

  render () {
    const classNames = ['side-pane menu']
    let content = this.renderFullMenu()

    if (this.props.menuOpen === false) {
      classNames.push('collapsed')
      content = this.renderCollapsedMenu()
    }

    return (
      <nav className={classNames.join(' ')}>
        {content}
      </nav>
    )
  }
}



// WEBPACK FOOTER //
// ./ui/side_menu/component.js